import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=36b37f56&"
import script from "./Inquiries.vue?vue&type=script&lang=js&"
export * from "./Inquiries.vue?vue&type=script&lang=js&"
import style0 from "./Inquiries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports